const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://n2mk1jgk0l.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://7qyvbgk351.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.saas.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.saas.forwoodsafety.com'
  }
};

export default config;